/* eslint-disable */
import { useState, useEffect } from 'react';
import { pengadaanAPI } from './api';

// ============================================
// HOOK: usePR
// ============================================
export function usePR(filterStatus = '') {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  async function fetchPR() {
    setLoading(true);
    try {
      const params = filterStatus ? { status: filterStatus } : {};
      const result = await pengadaanAPI.getAllPR(params);
      if (result.ok) {
        setData(result.data.data || []);
      } else {
        setError(result.data.message);
      }
    } catch (err) {
      setError('Gagal mengambil data PR');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchPR(); }, [filterStatus]);

  return { data, loading, error, refetch: fetchPR };
}

// ============================================
// HOOK: usePO
// ============================================
export function usePO(filterStatus = '') {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  async function fetchPO() {
    setLoading(true);
    try {
      const params = filterStatus ? { status: filterStatus } : {};
      const result = await pengadaanAPI.getAllPO(params);
      if (result.ok) {
        setData(result.data.data || []);
      } else {
        setError(result.data.message);
      }
    } catch (err) {
      setError('Gagal mengambil data PO');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchPO(); }, [filterStatus]);

  return { data, loading, error, refetch: fetchPO };
}

// ============================================
// HOOK: useGR
// ============================================
export function useGR() {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  async function fetchGR() {
    setLoading(true);
    try {
      const result = await pengadaanAPI.getAllGR();
      if (result.ok) {
        setData(result.data.data || []);
      } else {
        setError(result.data.message);
      }
    } catch (err) {
      setError('Gagal mengambil data GR');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchGR(); }, []);

  return { data, loading, error, refetch: fetchGR };
}

// ============================================
// HOOK: useDPH
// ============================================
export function useDPH() {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  async function fetchDPH() {
    setLoading(true);
    try {
      const result = await pengadaanAPI.getAllDPH();
      if (result.ok) {
        setData(result.data.data || []);
      } else {
        setError(result.data.message);
      }
    } catch (err) {
      setError('Gagal mengambil data DPH');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchDPH(); }, []);
  return { data, loading, error, refetch: fetchDPH };
}